<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Fechar Espelho de Ponto</div>
      </div>
      <div class="card-body">
        <div class="row" v-if="loaded">
          <div class="col-md-12">
            <table class="table table-hover">
              <tr>
                <td>
                  <span class="bold">Razão Social:</span>
                  Innovare - Solucoes Inovadoras em Informatica LTDA
                </td>
                <td colspan="2">
                  <span class="bold">CNPJ:</span>
                  27.491.194/0001-21
                </td>
              </tr>
              <tr>
                <td>
                  <span class="bold">Nome:</span>
                  {{ data.user.name }}
                </td>
                <td>
                  <span class="bold">Data de Admissão:</span>
                  {{ data.user.admission_date_f }}
                </td>
                <td>
                  <span class="bold">CTPS:</span>
                  {{ data.user.ctps }}
                </td>
              </tr>
              <tr>
                <td>
                  <span class="bold">PIS/PASEP:</span>
                  {{ data.user.pis_pasep }}
                </td>
                <td>
                  <span class="bold">Função:</span>
                  {{ data.user.role.title }}
                </td>
                <td>
                  <span class="bold">Departamento:</span>
                  {{ data.user.department.title }}
                </td>
              </tr>
              <tr>
                <td>
                  <span class="bold">Período:</span>
                  {{ data.start_period }} até {{ data.end_period }}
                </td>
                <td>
                  <span class="bold">Feriados no Período:</span>
                  {{ data.holidays }} dia(s).
                </td>
                <td>
                  <span class="bold">Dias Úteis no Período:</span>
                  {{ data.usefull_days }} dias.
                </td>
              </tr>
              <tr>
                <td>
                  <span class="bold">Jornada de Trabalho:</span>
                  {{ data.journey }} | {{ data.hours_journey }} horas.
                </td>
                <td>
                  <span class="bold">Total Trabalhado no Período:</span>
                  {{ data.total_worked }} horas.
                </td>
                <td>
                  <span class="bold">Total à Trabalhar no Período:</span>
                  {{ data.total_working }} horas.
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span class="bold">Banco de horas no período:</span>
                  {{ data.bank_of_hours }} horas.
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="row" v-if="loaded">
          <div class="col-md-12">Marcações no Período</div>
          <div class="col-md-12">
            <table class="table table-hover">
              <thead>
                <th>Data</th>
                <th>Entrada</th>
                <th>Almoço</th>
                <th>Volta Almoço</th>
                <th>Saída</th>
                <th>Total</th>
                <th>Diferença</th>
              </thead>
              <tbody>
                <tr v-for="(check, index) in data.checks" :key="index">
                  <td>{{ formatDate(index) }}</td>
                  <td
                    :class="[
                      { 'text-blue': check[0] && check[0].check_request_id },
                      { 'text-green': check[0] && check[0].remote },
                      { 'text-purple': check[0] && check[0].manual },
                      { 'text-orange': check[0] && check[0].vacation },
                    ]"
                  >
                    {{
                      check[0] && check[0].vacation > 1
                        ? "Férias"
                        : check[0]
                        ? format(check[0].created_at)
                        : ""
                    }}
                  </td>
                  <td
                    :class="[
                      { 'text-blue': check[1] && check[1].check_request_id },
                      { 'text-green': check[1] && check[1].remote },
                      { 'text-purple': check[1] && check[1].manual },
                      { 'text-orange': check[1] && check[1].vacation },
                    ]"
                  >
                    {{
                      check[1] && check[1].vacation > 1
                        ? "Férias"
                        : check[1]
                        ? format(check[1].created_at)
                        : ""
                    }}
                  </td>
                  <td
                    :class="[
                      { 'text-blue': check[2] && check[2].check_request_id },
                      { 'text-green': check[2] && check[2].remote },
                      { 'text-orange': check[2] && check[2].vacation },
                    ]"
                  >
                    {{
                      check[2] && check[2].vacation > 1
                        ? "Férias"
                        : check[2]
                        ? format(check[2].created_at)
                        : ""
                    }}
                  </td>
                  <td
                    :class="[
                      { 'text-blue': check[3] && check[3].check_request_id },
                      { 'text-green': check[3] && check[3].remote },
                      { 'text-purple': check[3] && check[3].manual },
                      { 'text-orange': check[3] && check[3].vacation },
                    ]"
                  >
                    {{
                      check[3] && check[3].vacation > 1
                        ? "Férias"
                        : check[3]
                        ? format(check[3].created_at)
                        : ""
                    }}
                  </td>
                  <td>{{ check[4] ? check[4] : "" }}</td>
                  <td>{{ check[6] ? check[6] : "" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <button
              class="btn btn-block btn-info"
              v-if="!search.closed"
              @click="closeMirror"
            >
              Fechar Espelho de Ponto
            </button>
            <a
              class="btn btn-block btn-info"
              v-if="search.closed"
              :href="downloadMirror(search.mirror_id)"
              target="_blank"
            >
              Baixar Espelho de Ponto
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      users: [],
      bankOfHours: "",
      loaded: false,
      search: {
        year: parseInt(moment().year(), 10),
        month: parseInt(moment().month(), 10),
      },
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  computed: {
    years: function () {
      let lastYear = parseInt(moment().year(), 10);
      let availableYears = [];
      let firstYear = 2019;

      for (lastYear; lastYear >= firstYear; lastYear--) {
        availableYears.push(lastYear);
      }

      return availableYears;
    },
    months: function () {
      const self = this;
      let thisYear = parseInt(moment().year(), 10);
      let availableMonths = [];
      let lastMonth;

      if (self.search.year === thisYear) {
        lastMonth = parseInt(moment().month(), 10);
      } else {
        lastMonth = 11;
      }
      for (let i = 0; i <= lastMonth; i++) {
        availableMonths.push(i);
      }

      return availableMonths;
    },
  },
  methods: {
    downloadMirror: function (id) {
      return (
        this.$store.state.url +
        "/export/point_mirror/" +
        id +
        "/Innov@AR3PointMirror2120INnv"
      );
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
    format: function (date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    getEntity: function () {
      const self = this;
      const api = this.$store.state.api + "point-mirror";

      self.$http
        .post(api, self.search)
        .then((response) => {
          self.data = response.data;
          self.loaded = true;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    closeMirror: function () {
      const self = this;
      const api = this.$store.state.api + "point-mirror/close";

      self.data.month = self.search.month;
      self.data.year = self.search.year;
      self.$http
        .post(api, self.data)
        .then((response) => {
          self.data = response.data;
          self.loaded = true;
          self.$message(
            "Sucesso",
            "Espelho de ponto do período fechado com sucesso",
            "success"
          );
          self.$router.push(
            "/point-mirror/" + self.search.month + "/" + self.search.year
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    setTimeout(function () {
      let mirrorData = self.$store.state.closeMirror;

      self.search = mirrorData;
      self.search.month = Number(self.search.month) + Number(1);

      self.getEntity();
    }, 1000);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/PointMirror/View.vue